<template>
  <div
    class="ui-badge"
    :class="getClassBadge"
    :style="getStyleBadge"
  >
    <template v-if="badge.name">{{ badge.name }}</template>
    <slot v-else/>
    <ui-icon
      v-if="hasDelete"
      name="roundClose"
      :width="12"
      :height="12"
      @click="$emit('delete', badge.id)"
      class="ui-badge-icon__delete"
    />
  </div>
</template>

<script>
import UiIcon from '../icons/UiIcon.vue'
import { COMPONENT_SIZE } from '../../libs/helpConsts'
const BADGE_TYPES = ['success', 'warning', 'danger']

export default {
  name: 'UiBadge',
  components: { UiIcon },
  props: {
    badge: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasDelete: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'success',
      validator (type) {
        return BADGE_TYPES.includes(type)
      }
    },
    size: {
      type: String,
      default: 'm',
      validator (size) {
        return COMPONENT_SIZE.includes(size)
      }
    }
  },

  computed: {
    getStyleBadge () {
      if (this.disabled) return
      return {
        color: this.badge?.text_color,
        backgroundColor: this.badge?.bg_color
      }
    },

    getClassBadge () {
      return [
        `size-${this.size}`,
        {
          disabled: this.disabled
        },
        this.type
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-badge {
  display: flex;
  align-items: center;
  width: min-content;
  padding: 6px 8px;
  color: $light-01;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  white-space: nowrap;
  text-align: center;
  fill: $light-01;
  border-radius: $border-radius-01;

  &.disabled {
    color: $gray-2;
  }

  &.size {
    &-s {
      padding: 1px 8px;
      font-weight: 400;
    }
    &-m {
      padding: 4px 8px;
    }
    &-l {
      padding: 6px 8px;
      font-size: 13px;
    }
  }
}

.success {
  background-color: $green;
}

.danger {
  background-color: $red;
}

.warning {
  background-color: $orange-1;
}

.ui-badge-icon__delete {
  margin-left: 5px;
  fill: $gray-7;
  cursor: pointer;
}
</style>
